module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "title": "EDIT FOLDER",
      "id": _vm.id,
      "value": _vm.value,
      "extra-class": "modal-sm"
    },
    on: {
      "shown": _vm.clear,
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('button', {
          staticClass: "btn green mt-ladda-btn ladda-button",
          attrs: {
            "data-style": "expand-left"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editFolder(_vm.folderId, _vm.editFolderName)
            }
          }
        }, [_c('span', {
          staticClass: "ladda-label"
        }, [_vm._v("OK")])]), _vm._v(" "), _c('button', {
          staticClass: "btn default",
          attrs: {
            "data-dismiss": "modal"
          }
        }, [_vm._v("Cancel")])]
      },
      proxy: true
    }])
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "edit-folder"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('edit-folder.name')
    }
  }, [_c('label', {
    attrs: {
      "for": "edit-folder-name"
    }
  }, [_vm._v("Folder Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.editFolderName),
      expression: "editFolderName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "edit-folder-name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.editFolderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editFolderName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('edit-folder.name')),
      expression: "errors.has('edit-folder.name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('edit-folder.name')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3834418b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/reports/EditFolderModal.vue
// module id = 1608
// module chunks = 1